
<div>
  <p-button class="mr-2" icon="pi pi-plus" label="Agregar días libres" (click)="open(content)" styleClass="p-button-success p-button-outlined" ></p-button>
</div>

<ng-template style="border: 0px; z-index: 100;" #content let-modal>
  <div class="modal-header">
      <h2 class="mb-0 font-semibold" style="font-family: 'Poppins', sans-serif !important;">Agregar día libre</h2>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
      </button>
  </div>

  <div class="modal-body">
      <form>
          <!-- Fila 1 -->
          <div class="row">
              <!-- Trabajador -->
              <div class="col col-12">
                  <p-dropdown [options]="trabajadores_aux" [(ngModel)]="trabajador" placeholder="Seleccione un trabajador" optionLabel="nombre"
                      [showClear]="true" [filter]="true" filterBy="nombre" [style]="{ width: '100%', padding: '4px' }" [ngModelOptions]="{standalone: true}"></p-dropdown>
              </div>
              <!-- Fecha -->
              <div class="col col-12">
                  <mat-form-field class="example-full-width" appearance="outline">
                      <mat-label>Fecha</mat-label>
                      <input matInput [matDatepicker]="picker" (dateChange)="obtener_fecha($event)" />
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker touchUI #picker></mat-datepicker>
                  </mat-form-field>
              </div>
          </div>

          <!-- Fila 2 -->
          <div class="row">
              <!-- Horas Extras -->
              <div class="col">
                  <mat-form-field class="example-full-width" appearance="outline">
                      <mat-label>Horas</mat-label>
                      <input type="text" matInput name="diasLibres" [(ngModel)]="diasLibres.horas" autonumeric [options]="optionsDecimal">

                  </mat-form-field>
              </div>
          </div>
          <!-- Fila 3 -->
          <div class="row">

              <!-- Descripción -->
              <div class="col">
                  <mat-form-field class="example-full-width" appearance="outline">
                      <mat-label>Descripción</mat-label>
                      <input type="text" matInput matInput name="descripcion" [(ngModel)]="diasLibres.descripcion">

                  </mat-form-field>
              </div>
          </div>
      </form>
  </div>

  <div class="modal-footer">
      <button type="button" class="btn btn-outline-danger" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">Cancelar</span>
      </button>
      <button type="button" class="btn btn-outline-success" (click)="enviar()">Guardar</button>
  </div>

</ng-template>
